module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mx-0 px-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": "",
      "dark": ""
    }
  }, [_c('v-card-title', [_vm._t("form-header")], 2), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_vm._t("form-fields")], 2), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-flex', {
    attrs: {
      "xs4": "",
      "offset-xs6": ""
    }
  }, [_vm._t("form-commands")], 2)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ae3fb712","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/formHelper.vue
// module id = 340
// module chunks = 0